export default __webpack_public_path__ + "static/media/rain-1.7661df62.png";